/**
 * Query cache configuration constants for React Query
 * These values control how long data stays fresh and cached
 */
export const QueryCacheConstants = {
  // Default cache times (in milliseconds)
  DEFAULT_STALE_TIME: 5 * 60 * 1000, // 5 minutes
  DEFAULT_GC_TIME: 10 * 60 * 1000, // 10 minutes

  // Short cache times for frequently changing data
  SHORT_STALE_TIME: 60 * 1000, // 1 minute
  SHORT_GC_TIME: 5 * 60 * 1000, // 5 minutes

  // Long cache times for relatively static data
  LONG_STALE_TIME: 15 * 60 * 1000, // 15 minutes
  LONG_GC_TIME: 30 * 60 * 1000, // 30 minutes

  // No cache for real-time data
  NO_CACHE: 0,
} as const;
